import React from "react";
import { AuthenticationInfoType } from "../utility/types";
import getUrl from "../utility/getUrl";
import axios, { HttpStatusCode } from "axios";

interface IProps {
  auth: AuthenticationInfoType;
}

class UserInfo extends React.Component<IProps> {
  state = {
    loading: false,
    error: "",
    userId: "",
    userinfo: "",
  };

  isUUID = function (uuid: string) {
    let s = "" + uuid;

    let matches = s.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
    if (matches === null) {
      return false;
    }
    return true;
  };

  handleOk = async () => {
    try {
      const userId = this.state.userId.trim();

      if (!userId) {
        this.setState({
          error: "Please enter user Id",
        });
        return;
      }

      if (!this.isUUID(userId)) {
        this.setState({
          error: "Please enter a valid user Id (GUID format aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee)",
        });
        return;
      }

      this.setState({
        loading: true,
      });

      const url = getUrl("userInfoById");
      const result = await axios.post(url, JSON.stringify([userId]), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.props.auth.accessToken}`,
          "Cache-Control": "no-cache",
          "Access-Control-Allow-Origin": "*",
          "X-Requested-With": "XMLHttpRequest",
        },
        withCredentials: false,
      });

      let error = "";
      let userinfo = "";
      if (result.status !== HttpStatusCode.Ok) {
        error = "User not found";
        if (result.status === 401) {
          error = "Sorry, you have no access to this service";
        }
      } else {
        userinfo = result.data;
      }
      this.setState({
        loading: false,
        error: error,
        userinfo: JSON.stringify(userinfo, null, 2),
      });
    } catch (err) {
      this.setState({
        loading: false,
        error: "ups - exception",
      });
    }
  };

  handleChange = (ev: any) => {
    this.setState({
      error: "",
      loading: false,
      userinfo: "",
      userId: ev.target.value,
    });
  };

  onFocus = (ev: any) => {
    if (ev.target) {
      ev.target.select();
    }
  };

  render() {
    let statusComponent = <div className="output-text--loading">&nbsp;</div>;
    if (this.state.loading) {
      statusComponent = <div className="output-text--loading">Loading ...</div>;
    } else {
      if (this.state.error) {
        statusComponent = <div className="output-text--error">{this.state.error}</div>;
      }
    }

    return (
      <div className="user-info">
        <h2>Get User Info</h2>

        <label>
          <div className="label">User Id:</div>
          <input
            className="bottom-border"
            type="text"
            onFocus={this.onFocus}
            value={this.state.userId}
            onChange={this.handleChange}
          />
        </label>

        <label>
          <div className="label">User info:</div>
          <div className="output-text">
            <pre>{this.state.userinfo}</pre>
          </div>
        </label>

        {statusComponent}

        <button className="button" onClick={this.handleOk}>
          Get User Info
        </button>
      </div>
    );
  }
}

export default UserInfo;
